import { useNavigate, useSearchState } from "common/router/hooks";
import Navigate from "common/router/Navigate";

import { AuthenticationRedirectAfterLookup } from "client/accounts/types";
import TextButton from "client/common/components/buttons/TextButton";
import { INITIAL_CLIENT_DATA } from "client/common/utils";
import { Paths, urls } from "client/routes";

import AuthPage from "./AuthPage";
import EmailLookupForm from "./EmailLookupForm";
import PhoneNumberLookupForm from "./PhoneNumberLookupForm";

import styles from "../../styles/LookupPage.module.less";

const { is_authenticated: isAuthenticated, has_completed_signup: hasCompletedSignup } =
  INITIAL_CLIENT_DATA;

const LookupPage = () => {
  const navigate = useNavigate();
  const [search] = useSearchState<Paths["accounts"]["lookup"]>({});

  if (isAuthenticated && hasCompletedSignup) {
    return <Navigate dest={search.next ? { to: search.next } : urls.accounts.detail()} />;
  }

  const FormChoice = search?.method === "email" ? EmailLookupForm : PhoneNumberLookupForm;

  const formDescription =
    search?.method === "email"
      ? "Enter your email below. We use your email to look up your previous records and follow up with any questions."
      : "Enter your phone number below. We use your phone number to look up your previous records and follow up with any questions.";

  // TODO: allow proper population of phone or email fields + appropriate redirect to sign up form.
  // Currently, it's possible to get a null value populating from lookup

  return (
    <AuthPage
      title="Sign in or register to continue"
      description={formDescription}
      flash={search.flash}
    >
      <div className={styles.form}>
        <FormChoice
          initialValue={search.phone}
          onSuccess={({ authentication_redirect, number, email }) =>
            navigate(
              authentication_redirect === AuthenticationRedirectAfterLookup.SigninPhone ||
                authentication_redirect === AuthenticationRedirectAfterLookup.SigninEmail
                ? urls.accounts.login({
                    search: { ...search, phone: `${number || ""}`, email: email || "" },
                  })
                : urls.accounts.signup({
                    search: { ...search, phone: `${number || ""}`, email: `${email || ""}` },
                  }),
            )
          }
        />
        <p className={styles.help}>
          <TextButton dest={urls.accounts.signup({ search })}>Sign Up</TextButton>
          <span className={styles.space}>·</span>
          <TextButton dest={urls.accounts.login({ search })}>Login</TextButton>
        </p>
      </div>
    </AuthPage>
  );
};

export default LookupPage;
